import { useGetApiSchoolSettingsQuery } from 'shared/api/gsp';

export const useSchoolTimezone = () =>
  useGetApiSchoolSettingsQuery()?.data?.timeZone;
